import type { FetchService } from '@affine/core/modules/cloud';
import { type DocServer, WorkspaceDBService } from '@toeverything/infra';

export class CloudStaticDocStorage implements DocServer {
  name = 'cloud-static';
  constructor(
    private readonly workspaceId: string,
    private readonly fetchService: FetchService
  ) {}
  pullDoc(
    docId: string,
    stateVector: Uint8Array
  ): Promise<{
    data: Uint8Array;
    serverClock: number;
    stateVector?: Uint8Array;
  } | null> {
    return this.pull(docId, stateVector);
  }
  pushDoc(_docId: string, _data: Uint8Array): Promise<{ serverClock: number }> {
    return Promise.resolve({ serverClock: 0 });
  }
  loadServerClock(_after: number): Promise<Map<string, number>> {
    return Promise.resolve(new Map([[this.workspaceId, 0]]));
  }
  subscribeAllDocs(
    _cb: (updates: {
      docId: string;
      data: Uint8Array;
      serverClock: number;
    }) => void
  ): Promise<() => void> {
    return Promise.resolve(() => {});
  }
  waitForConnectingServer(_signal: AbortSignal): Promise<void> {
    return Promise.resolve();
  }
  disconnectServer(): void {}
  onInterrupted(_cb: (reason: string) => void): void {}
  dispose(): void {
    this.disconnectServer();
  }

  async pull(
    docId: string,
    state?: Uint8Array
  ): Promise<{
    data: Uint8Array;
    state?: Uint8Array | undefined;
    serverClock: number;
  } | null> {
    if (state && state.length > 0) {
      return {
        data: new Uint8Array(),
        state: state,
        serverClock: 0,
      };
    }

    // TODO ??? получать все таблицы рабочего пространства
    if (
      WorkspaceDBService.isDBDocId(docId) &&
      docId.includes('docProperties')
    ) {
      try {
        const response = await this.fetchService.fetch(
          `/api/workspaces/${this.workspaceId}/doc-properties`,
          { priority: 'high' }
        );
        if (response.ok) {
          const arrayBuffer = await response.arrayBuffer();

          return { data: new Uint8Array(arrayBuffer), serverClock: 0 };
        }

        return { data: new Uint8Array(), serverClock: 0 };
      } catch (error) {
        console.error(error);
        return { data: new Uint8Array(), serverClock: 0 };
      }
    } else
      try {
        const response = await this.fetchService.fetch(
          `/api/workspaces/${this.workspaceId}/docs/${docId}`,
          { priority: 'high' }
        );
        if (response.ok) {
          const arrayBuffer = await response.arrayBuffer();

          return { data: new Uint8Array(arrayBuffer), serverClock: 0 };
        }

        return { data: new Uint8Array(), serverClock: 0 };
      } catch (error) {
        console.error(error);
        return { data: new Uint8Array(), serverClock: 0 };
      }
  }
}
